import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const LogInCode = () => {
    return (
        <div id="log-in-code-page">
            <div className="title-log-in xpr-2 xpl-2 xmb-5">
                <span>کد تایید را وارد نمایید</span>
            </div>
            <div className="description xpx-2 xmb-6">
                <p>کد ۵ رقمی پیامک شده به موبایل‌تان را وارد کنید.</p>
            </div>
            <div className="input-log-in position-relative xmb-6">
                <input type="text" className="form-control input-normal" id="set-persian-number-input" disabled/>
                <div className="phone-icon position-absolute">
                    <IconName name="phone" className="icon"/>
                </div>
                <div className="change-code position-absolute" id="change-button-code-log-in"><span>ویرایش</span></div>
            </div>
            <div className="code xmb-6">
                <fieldset className="number-code" id="parent-input-cods">
                    <input type="number" name='code' id="first-code" className='code-input form-control' maxLength="1" placeholder="___" required/>
                    <input type="number" name='code' className='code-input form-control' maxLength="1" placeholder="___" required/>
                    <input type="number" name='code' className='code-input form-control' maxLength="1" placeholder="___" required/>
                    <input type="number" name='code' className='code-input form-control' maxLength="1" placeholder="___" required/>
                    <input type="number" name='code' className='code-input form-control' maxLength="1" placeholder="___" required/>
                </fieldset>
            </div>
            <div className="button-log-in-code xmb-6">
                <button id="get-phone-code" disabled={true}>ارسال مجدد کد تا <span id="timer-code" className="timer-code-login">00:00</span> دیگر</button>
            </div>
            <div className="log-in-password-button xmt-6 xmb-2 text-center">
                <span className="open-password" id="login-password-link">ورود با رمز عبور</span>
            </div>
        </div>
    );
};

export default LogInCode;
